class Store {
  constructor() {
    riot.observable(this);
    this.state = {
      loading: false,
      dialog: {
        show: false,
        message: null,
        status: null
      }
    };
  }

  setDialog(dialog) {
    this.setState({ ...this.state, dialog });
  }

  setLoading(loading) {
    this.setState({ ...this.state, loading });
  }

  getState() {
    return { ...this.state };
  }

  setState(state) {
    this.state = state;
    this.trigger('change', { ...this.state });
  }
}

export default new Store();